import { EventEmitter, ViewChildren } from '@angular/core';
import { Output } from '@angular/core';
import { Input } from '@angular/core';
import { AfterViewInit } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { ToastrService } from 'ngx-toastr';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';

@Component({
  selector: 'app-filterpopup',
  templateUrl: './filterpopup.component.html',
  styleUrls: ['./filterpopup.component.css']
})
export class FilterpopupComponent implements OnInit, AfterViewInit {

  @ViewChildren('input') firstipcontrol;

  empColl: any = [];
  loantypeColl: any = [];
  bonustypeColl: any = [];
  expensetypeColl: any = [];
  reimbursetypeColl: any = [];
  finetypeColl: any = [];
  requesttypeColl: any = [];
  contracttypeColl: any = [];
  incidenttypeColl: any = [];
  branchColl: any = [];
  paymentstatusColl: any = [];
  relievetypeColl: any = [];

  @Input() formname: string = "";

  @Input() employeeid: any = null;
  @Input() fromdate: any = null;
  @Input() todate: any = null;
  @Input() loantypeid: any = null;
  @Input() bonustypeid: any = null;
  @Input() expensetypeid: any = null;
  @Input() reimbursetypeid: any = null;
  @Input() finetypeid: any = null;
  @Input() requesttypeid: any = null;
  @Input() contracttypeid: any = null;
  @Input() incidenttypeid: any = null;
  @Input() branchid: any = null;
  @Input() relievetypeid: any = null;
  @Input() paymentstatus: string = "";

  statusColl: any = [];

  @Output() emitData = new EventEmitter();

  @Output() cbapplyChanged = new EventEmitter();
  @Output() filterChanged = new EventEmitter<number>();

  dateCustomClasses: DatepickerDateCustomClasses[];

   forminvalidname = ['Holidays', 'APPROVALS'];

  constructor(private appService: AppdataService, public loginService: LoginserviceService, private route: ActivatedRoute,
    public router: Router, private toastr: ToastrService, private activeModal: NgbActiveModal,) {

    this.dateCustomClasses = [
      { date: new Date(), classes: ['bg-warning'] },
    ];
  }




  ngOnInit() {
    try {

      this.fngetEmployee();
      this.fngetLoantype();
      this.fngetBonustype();
      this.fngetExpensetype();
      this.fngetReimbursetype();
      this.fngetFinetype();
      this.fngetStatus();
      this.fngetRequesttype();
      this.fngetContracttype();
      this.fngetIncidenttype();
      this.fngetBranch();
      this.fngetPaymentStatus();
      this.fngetRelieveType();
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  ngAfterViewInit() {
    ////this.firstipcontrol.first.nativeElement.focus();
  }

  fngetStatus() {
    this.statusColl.push({ displayname: "Active", value: "" });
    this.statusColl.push({ displayname: "InActive", value: "INACTIVE" });
    this.statusColl.push({ displayname: "All", value: "ALL" });
  }
  fngetPaymentStatus() {
    this.paymentstatusColl.push({ displayname: "PAID", value: 'PAID' });
    this.paymentstatusColl.push({ displayname: "UNPAID", value: 'UNPAID' });
    this.paymentstatusColl.push({ displayname: "ALL", value: '' });

  }
  fngetEmployee() {
    var data = {
      'empid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getEmpListView(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.empColl = res.json().result;
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  fngetLoantype() {
    var data = {
      'loantypeid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getLoanType(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.loantypeColl = res.json().result;
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fngetBonustype() {
    var data = {
      'bonustypeid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getBonusType(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.bonustypeColl = res.json().result;
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fngetExpensetype() {
    var data = {
      'expensetypeid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getExpenseType(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.expensetypeColl = res.json().result;
            console.log(this.expensetypeColl)
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  fngetReimbursetype() {
    var data = {
      'reimbursetypeid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getReimburseType(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.reimbursetypeColl = res.json().result;

          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  fngetFinetype() {
    var data = {
      'finetypeid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getFineType(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.finetypeColl = res.json().result;
            console.log(this.finetypeColl)
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  fngetRequesttype() {
    var data = {
      'requesttypeid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getRequestType(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.requesttypeColl = res.json().result;
            console.log(this.requesttypeColl)
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  fngetContracttype() {
    var data = {
      'contracttypeid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getContractType(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.contracttypeColl = res.json().result;

          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fngetIncidenttype() {
    var data = {
      'incidenttypeid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getIncidentType(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.incidenttypeColl = res.json().result;

          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  fngetBranch() {
    var data = {
      'branchid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getBranch(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.branchColl = res.json().result;

          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  fngetRelieveType() {
    var data = {
      'relievetypeid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getRelieveType(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.relievetypeColl = res.json().result;

          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  //Save Btn Click
  fnApplyFilter() {
    try {
      var data = {
        status: 'DONE',
        employeeid: this.employeeid,
        empname: this.fnGetEmployeename(),
        fromdate: this.fromdate,
        todate: this.todate,
        loantypeid: this.loantypeid,
        loantype: this.fnGetLoantypename(),
        bonustypeid: this.bonustypeid,
        bonustypename: this.fnGetBonustypename(),
        expensetypeid: this.expensetypeid,
        expensetypename: this.fnGetExpensetypename(),
        reimbursetypeid: this.reimbursetypeid,
        reimbursetypename: this.fnGetReimbursetypename(),
        finetypeid: this.finetypeid,
        finetypename: this.fnGetFinetypename(),
        requesttypeid: this.requesttypeid,
        requesttypename: this.fnGetRequesttypename(),
        contracttypeid: this.contracttypeid,
        contracttypename: this.fnGetContracttypename(),
        incidenttypeid: this.incidenttypeid,
        incidenttypename: this.fnGetIncidenttypename(),
        branchid: this.branchid,
        branchname: this.fnGetBranchname(),
        relievetypeid: this.relievetypeid,
        relievetypename: this.fnGetRelievetypename(),
        paymentstatus: this.paymentstatus,
      }
      this.emitData.emit(data);
      this.activeModal.close(true);

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnGetEmployeename() {
    var empname = "";
    for (let abo of this.empColl) {
      if (this.employeeid === abo.empid) {
        empname = abo.empname;
      }
    }

    return empname
  }
  fnGetLoantypename() {
    var loantype = "";
    for (let abo of this.loantypeColl) {
      if (this.loantypeid === abo.loantypeid) {
        loantype = abo.loantype;
      }
    }

    return loantype
  }

  fnGetBonustypename() {
    var bonustypename = "";
    for (let abo of this.bonustypeColl) {
      if (this.bonustypeid === abo.bonustypeid) {
        bonustypename = abo.bonustypename;
      }
    }

    return bonustypename
  }
  fnGetExpensetypename() {
    var expensetypename = "";
    for (let abo of this.expensetypeColl) {
      if (this.expensetypeid === abo.expensetypeid) {
        expensetypename = abo.expensetypename;
      }
    }

    return expensetypename
  }

  fnGetReimbursetypename() {
    var reimbursetypename = "";
    for (let abo of this.reimbursetypeColl) {
      if (this.reimbursetypeid === abo.reimbursetypeid) {
        reimbursetypename = abo.reimbursetypename;
      }
    }

    return reimbursetypename
  }
  fnGetFinetypename() {
    var finetypename = "";
    for (let abo of this.finetypeColl) {
      if (this.finetypeid === abo.finetypeid) {
        finetypename = abo.finetypename;
      }
    }

    return finetypename
  }
  fnGetRequesttypename() {
    var requesttypename = "";
    for (let abo of this.requesttypeColl) {
      if (this.requesttypeid === abo.requesttypeid) {
        requesttypename = abo.requesttypename;
      }
    }

    return requesttypename
  }

  fnGetContracttypename() {
    var contracttypename = "";
    for (let abo of this.contracttypeColl) {
      if (this.contracttypeid === abo.contracttypeid) {
        contracttypename = abo.contracttypename;
      }
    }

    return contracttypename
  }
  fnGetIncidenttypename() {
    var incidenttypename = "";
    for (let abo of this.incidenttypeColl) {
      if (this.incidenttypeid === abo.incidenttypeid) {
        incidenttypename = abo.incidenttypename;
      }
    }

    return incidenttypename
  }
  fnGetBranchname() {
    var branchname = "";
    for (let abo of this.branchColl) {
      if (this.branchid === abo.branchid) {
        branchname = abo.branchname;
      }
    }

    return branchname
  }
  fnGetRelievetypename() {
    var relievetypename = "";
    for (let abo of this.relievetypeColl) {
      if (this.relievetypeid === abo.relievetypeid) {
        relievetypename = abo.relievetypename;
      }
    }

    return relievetypename
  }
  fnEmployeeSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.empname.toLocaleLowerCase().indexOf(term) > -1 ||
      item.staffcode.toLocaleLowerCase().indexOf(term) > -1;
  }

  public decline() {
    this.activeModal.close(false);
  }


  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }



}
